import { render } from "./coupon.vue?vue&type=template&id=9c9ae0a8&scoped=true"
import script from "./coupon.vue?vue&type=script&lang=js"
export * from "./coupon.vue?vue&type=script&lang=js"

import "./coupon.vue?vue&type=style&index=0&id=9c9ae0a8&lang=less&scoped=true"

import exportComponent from "D:\\myWorkspace\\CoreServiceAzure\\CoreServiceCloud\\MyNews\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c9ae0a8"]])

export default __exports__